import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IntegrationDefinitionSummary } from '../../shared/types/integrationConfiguration';
import { integrationDefinitionsApi } from '../services/IntegrationDefinitionsService';

interface IIntegrationDefinitionsSlice {
  integrationDefinitions: IntegrationDefinitionSummary[];
}

const initialState: IIntegrationDefinitionsSlice = {
  integrationDefinitions: [],
};

const slice = createSlice({
  name: 'integrationDefinitions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      integrationDefinitionsApi.endpoints.getRoles.matchFulfilled,
      (state: IIntegrationDefinitionsSlice, { payload }) => {
        return {
          ...state,
          integrationDefinitions: [...payload.roles],
        };
      },
    );
    builder.addMatcher(
      integrationDefinitionsApi.endpoints.createIntegrationDefinition.matchFulfilled,
      (state: IIntegrationDefinitionsSlice, { payload: { role } }) => {
        return {
          ...state,
          integrationDefinitions: [...state.integrationDefinitions, role],
        };
      },
    );
    builder.addMatcher(
      integrationDefinitionsApi.endpoints.updateIntegrationDefinition.matchFulfilled,
      (state: IIntegrationDefinitionsSlice, { payload: { role } }) => {
        return {
          ...state,
          integrationDefinitions: state?.integrationDefinitions?.map(
            (integrationDefinition) => (integrationDefinition.id === role.id && role) || integrationDefinition,
          ),
        };
      },
    );
    builder.addMatcher(
      integrationDefinitionsApi.endpoints.deleteIntegrationDefinition.matchFulfilled,
      (state: IIntegrationDefinitionsSlice, { payload, meta }) => {
        const args = meta.arg.originalArgs;
        const { roleId } = args;
        return {
          ...state,
          integrationDefinitions: state?.integrationDefinitions?.filter((role) => role.id !== roleId),
        };
      },
    );
  },
});

export default slice.reducer;

export const selectIntegrationDefinitions = (state: RootState) => state.integrationDefinitions.integrationDefinitions;
